import React, { useContext } from "react";
import styled from "styled-components";

import { Row, Box } from "../../../../comps";
import ContentView from "./content";

const Wrapper = styled(Row)`
  width: 100%;
  height: 100%;
  position: relative;
  align-items: center;
  border-radius: 10px;
  background: ${({ theme }) => theme.color.BLACK_0};
  overflow: hidden;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
`;

const Img = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 1;
`;

const Overlay = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle,
    ${({ theme }) => theme.color.BLACK_0} 0%,
    ${({ theme }) => theme.color.BLACK_0} 10%,
    transparent 100%
  );
`;

const ContentWrapper = styled(Row)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export default ({ roomInfo, refresh }) => {
  const { thumbnail } = roomInfo || {};

  return (
    <Wrapper>
      <Img src={thumbnail} />
      <Overlay />
      <ContentWrapper>
        <ContentView roomInfo={roomInfo} refresh={refresh} />
      </ContentWrapper>
    </Wrapper>
  );
};
